@let config = config$ | async;
@let logoUrl = logoUrl$ | async;
@let loading = loading$ | async;
@let error = error$ | async;
@let submitted = submitted$ | async;
@let formInvalid = (formStatus$ | async) !== "VALID";
@let buttonTextColor = buttonTextColor$ | async;

@if (logoUrl) {
  <img
    [src]="logoUrl"
    [style.width.px]="config?.logo?.width"
    [style.height.px]="config?.logo?.height"
    alt="Logo"
    class="widget-logo" />
}

@if (config?.content?.showHeader !== false) {
  <h2 class="widget-header">{{ config?.content?.title?.[lang] }}</h2>
}

@if (error) {
  <rms-toast
    class="w-full"
    color="ruber"
    icon="remix:System/error-warning-line"
    [canClose]="true"
    message="libs.widget-landing.call-error.message"
    (closed)="error$.next(false)" />
}

@if (submitted) {
  <p class="widget-success">We'll call you shortly!</p>
} @else {
  <form
    [formGroup]="form"
    (ngSubmit)="submit()"
    class="flex flex-col gap-4"
    [class.is-preview]="previewMode">
    @if (config?.content?.nameAvailable) {
      <mat-form-field
        class="widget-field"
        subscriptSizing="dynamic">
        <mat-icon
          matPrefix
          svgIcon="remix:User & Faces/user-line" />

        <input
          matInput
          [readonly]="previewMode"
          formControlName="name"
          [placeholder]="config?.content?.namePlaceholder?.[lang] || 'Your name'" />
      </mat-form-field>
    }

    @if (config?.content?.emailAvailable) {
      <mat-form-field
        class="widget-field"
        subscriptSizing="dynamic">
        <mat-icon
          matPrefix
          svgIcon="remix:Business/mail-line" />

        <input
          matInput
          [readonly]="previewMode"
          formControlName="email"
          type="email"
          [placeholder]="config?.content?.emailPlaceholder?.[lang] || 'Your email'" />
      </mat-form-field>
    }

    <rms-phone-input
      formControlName="phone"
      [allowedCountries]="config?.content?.phoneCountries?.length ? config!.content.phoneCountries : null"
      [defaultCountryCode]="config?.content?.defaultPhoneCountry ?? null" />

    <button
      class="widget-submit"
      [style.background-color]="config?.styles?.accentColor ?? '#3730a3'"
      [style.color]="buttonTextColor"
      [disabled]="!previewMode && (formInvalid || !!loading)"
      type="submit">
      {{ loading ? "Calling..." : config?.content?.button?.[lang] }}
    </button>
  </form>
}

<div class="widget-footer">
  <span>Powered by</span>
  <img
    src="/assets/img/logo/logo.svg"
    alt="Romulus"
    class="widget-footer-logo" />
</div>
